/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/store/actions/projects.actions.js
 * File: projects.actions.js
 * Created Date: Sunday, January 27th 2019, 7:14:05 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Feb 04 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { resolveProjects } from 'client/app/services/project.service'

export const GET_PROJECT_DATA = '[PROJECT] GET PROJECT DATA'
export const GET_PROJECT_DATA_SUCCESS = '[PROJECT] GET PROJECT DATA SUCCESS'
export const GET_PROJECT_DATA_FAILURE = '[PROJECT] GET PROJECT DATA FAILURE'

export const SET_ACTIVE_PROJECT = '[PROJECT] SET ACTIVE PROJECT'

export function getProjectsData (event) {
  return (dispatch, getState) => {
    dispatch(getProjectsDataRequest())
    return resolveProjects()
      .then(response => {
        dispatch(getProjectsDataSuccess(response))
        return (response)
      })
      .catch(err => {
        dispatch(getProjectsDataFail(err))
        return (err)
      })
  }
}

export function setActiveProject (id, token, name, star) {
  return {
    type: SET_ACTIVE_PROJECT,
    data: {
      id,
      token,
      name,
      star
    }
  }
}

function getProjectsDataRequest () {
  return {
    type: GET_PROJECT_DATA
  }
}

function getProjectsDataSuccess (data = {}) {
  return {
    type: GET_PROJECT_DATA_SUCCESS,
    data
  }
}

function getProjectsDataFail (error) {
  return {
    type: GET_PROJECT_DATA_FAILURE,
    error
  }
}
